module.exports = __webpack_public_path__ + "static/img/p5_cn.d637b2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mthfr/p5_cn.png
// module id = T6m4
// module chunks = 0